import { render, staticRenderFns } from "./NpAlert.vue?vue&type=template&id=30b0c72f&"
import script from "./NpAlert.vue?vue&type=script&lang=ts&"
export * from "./NpAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports